<template>
<!-- 文章集锦 -->
  <div id="articalSearchList">
    <div class="top-header">
      <div class="header-bg">
        <div class="search">
          <div style="position: relative;width: calc(100% - 44px);display: inline-block;vertical-align: middle">
            <i class="icon iconfont iconsousuo search-icon"></i>
            <input class="allInput searchBar" type="text" v-model="searchData.LiveName" style="padding: 0 30px 0 33px!important;">
            <i class="icon iconfont iconguanbi empty-icon" @touchstart="clearInput"></i>
          </div>
          <span class="f_w m_l_10 font14" style="color: white;white-space: nowrap;" @click="toUrl()">取消</span>
        </div>
        <div :class="{'top-menu': true, 'top-menu-active': showHeadMenu}" @click="toggleHeadMenu" style="display: none;">
          <i :class="{'icon':true, 'iconfont':true, 'iconhanbaocaidan': true, 'menu-icon':true, 'menu-icon-active': showHeadMenu}" style="font-size: 20px!important;"></i>
          <!-- 隐藏菜单 -->
          <div v-show="showHeadMenu" class="top-menu-list">
            <!-- <div style="">
              <i class="icon iconfont iconshuqian" style="color: #E71222;"></i>
              <span style="margin-left: 5px;font-size: 14px;">我的收藏</span>
            </div> -->
            <div style="margin-top:15px;">
              <i class="icon iconfont icongerenzhongxin1" style="color: #E71222;"></i>
              <span style="margin-left: 5px;font-size: 14px;">个人中心</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="artical-container">
      <!-- <div class="artical-header">
        <div class="interest">
          <i class="icon iconfont iconaixin" style="color: #E71222;font-size: 20px!important;font-weight: bold;line-height: 30px;"></i>
          <span class="interest-txt">兴趣</span>
        </div>
      </div> -->
      <div class="artical-list">
        <template v-if="totalArticleList.length > 0">
         <div class="onLive-item" v-for="(item, index) in totalArticleList" :key="index">
							<div>
								<div class="split_1_9 m_b_5">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_speak.png" style="width: 16px" alt="">
									</div>
									<div class="f_w font16 NoWrap">{{item.liveName}}</div>
								</div>
								<div class="split_1_9 m_b_5">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_date.png" style="width: 16px" alt="">
									</div>
									<div class="c_76B39D font14">{{item.liveDate}}</div>
								</div>
								<div class="split_1_9 m_b_5">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_time.png" style="width: 16px" alt="">
									</div>
									<div class="c_76B39D font14">{{item.liveTime}}</div>
								</div>
								<div class="split_1_9 m_b_20">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_speaker.png" style="width: 16px" alt="">
									</div>
									<div class="c_76B39D font14 NoWrap">{{item.speaker}}</div>
								</div>
								<div>
									<button class="btn_red font14 b_b" style="width: 80%;margin-left: 10%;padding: 6px" @click="goJumpLink(item)">参加</button>
								</div>
							</div>
            </div>
          <div v-if="notList" style="text-align:center;color:rgb(137,137,137);">没有更多了</div>
        </template>
        <div v-else style="text-align:center;margin-top: 50px;">
          {{noDataText}}
        </div>
      </div>
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>
<script>
import agreeBookDialog from "../../login/agreeBookDialog";
import merge from 'webpack-merge';
export default {
  name: 'articalSearchList',
   components: {
    agreeBookDialog
  },
  data () {
    return {
      baseUrl: process.env.config.baseUrl,
      searchData: {
        LiveName: ''
      },
      showPage: false,
      ABDialogShow:false,
      showHeadMenu: false,
      openId: '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      takedacode: this.$route.query.takedacode || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      showGuide: false,
      userInfo: {},
      fieldsList: JSON.parse(this.$route.query.fieldsList || '[]') || [],
      indicationList: [],
      articleList: [],
      totalArticleList: [],
      noDataText: '',
      pageIndex: 1,
      pageSize: 5,
      total: 0,
      totalPage: 0,
      skipcarouselCount: 0,
      notList: false,
      canSearch: true
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollHandler, true)
  },
  created () {

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/mobileOnLiveSearch?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = url
 }


     //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
     if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }


   if (!localStorage.TaToken && !this.takedacode) {
      let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/mobileOnLiveSearch?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = url
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          let isEmployee = window.localStorage.getItem('isEmployee')
          let allAxiox = ''
          if (isEmployee) {
            let data = {
              openId: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
          } else {
            let data = {
              openid: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
          }

          if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}

          allAxiox.then(msg => {
            console.log(msg, 'getDoctor')
            if (msg.isSuccess) {
              if (msg.data.status === 2) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else if (msg.data.status === 3) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else {
                if (msg.data.isFollowed) {
                  this.showPage = true
                  // 获取用户信息
                  this.getUserInfo()
                } else {
                  this.showGuide = true
                }
              }
            }
          })
        })
      } else {
        this.openId = localStorage.openId
        let isEmployee = window.localStorage.getItem('isEmployee')
        let allAxiox = ''
        if (isEmployee) {
          let data = {
            openId: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
        } else {
          let data = {
            openid: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
        }

        if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}

        allAxiox.then(msg => {
          console.log(msg, 'getDoctor')
          if (msg.isSuccess) {
            if (msg.data.status === 2) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else if (msg.data.status === 3) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else {
              if (msg.data.isFollowed) {
                this.showPage = true
                // 获取用户信息
                this.getUserInfo()
              } else {
                this.showGuide = true
              }
            }
          }
        })
      }
    }

    setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
      }, 1000);



  },
  mounted () {
    document.title = '武田直播'
    //监听如果页面发生滚动时
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scrollHandler, true)
    })
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
          //name: "agreeBook",
            this.ABDialogShow = true;
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    goJumpLink (slide) {
			let data = {
				liveName: slide.liveName,
				openId: this.openId,
				liveUrl: slide.liveUrl,
				liveId: slide.id
			}
			this.$axiox.post('/api/Live/mobile/log', data).then( p => {
        if (slide.liveUrl){
          if(slide.liveUrl.indexOf('?') >= 0){
            window.location.href = `${slide.liveUrl}&AttendType=WY`
          } else {
            window.location.href = `${slide.liveUrl}?AttendType=WY`
          }
          // window.location.href = slide.liveUrl
        }
			} )
    },
    toUrl () {
      this.searchData.LiveName = ''
      let queries = this.$route.query
      this.$router.push({
        path: '/mobileOnLive',
        query: {
          ...queries
        }
      })
    },
    toggleHeadMenu () {
      this.showHeadMenu = !this.showHeadMenu
    },
    // 获取用户信息
    getUserInfo () {
      let isEmployee = window.localStorage.getItem('isEmployee')
      let requestUrl2 = ''
      if (isEmployee) {
        requestUrl2 = this.$axiox.getNoRes('/Login/EmployeeWxUserInfo?openId=' + this.openId)
      } else {
        let data = {
          openId: this.openId
        }
        requestUrl2 = this.$axiox.postNoRes('/Login/WxUserInfo', data)
      }
      requestUrl2.then(msg => {
        console.log(msg, 'msg')
        if (msg.isSuccess) {
          this.userInfo = msg.data
          // 获取推荐文章
          let fields = this.fieldsList.filter(val => val.checked)
          this.getArticals(this.userInfo.department, fields)
        }
      })
    },
    // 获取推荐文章
    getArticals (department, fields) {
      console.log(department, fields, 'department, fields')
      this.notList = false
      this.finished = false
      let thisFields = fields.map(val => val.name)
      let fieldNames = fields.map(val => val.name)
      let str = ''
      fieldNames.forEach(item => {
        str = str + '&Fields=' + item
      })
      console.log(str, 'str')
      // let url = ''
      // if ((fieldNames && fieldNames.length > 0)) {
      //   url = `/api/Live/mobile/live/list?LiveName=${''}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}` + str
      // } else {
      //   url = `/api/Live/mobile/live/list?keywords=${''}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`
      // }
			let data = {
				LiveName: this.searchData.LiveName,
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
			}
      this.canSearch = false
      this.$axiox.getList(this.$commonJs.returnQuery('/api/Live/mobile/live/list', data)).then(res => {
        this.canSearch = true
        console.log(res, 'getArticals')
        setTimeout(() => {
          this.loading = false
        }, 500)
        if (res.data && res.data.length > 0) {
          for(let i = 0; i < res.data.length; i++) {
            this.totalArticleList.push(res.data[i])
          }
          this.total = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          for(let i = 0; i < res.data.length; i++) {
            this.totalArticleList.push(res.data[i])
          }
          this.total = 0
          this.totalPage = 0
          this.noDataText = '更多精彩内容，敬请期待！'
        }
      })
    },
    clearInput () {
      this.searchData.LiveName = ''
    },
    scrollHandler () {
      var scrollTop = document.documentElement.scrollTop; //滚动条的位置
      var windowHeitht = document.documentElement.clientHeight; //在页面上返回内容的可视高度
      var scrollHeight = document.documentElement.scrollHeight; //返回整个元素的高度（包括带滚动条的隐蔽的地方）
      //是否滚动到底部的判断
      if (scrollHeight - windowHeitht - scrollTop < 1) {
        console.log('滚到底了')
        // 页数加1
        this.pageIndex += 1
        if (this.pageIndex <= this.totalPage) {
          // 获取推荐文章
          let fields = this.fieldsList.filter(val => val.checked)
          this.getArticals(this.userInfo.department, fields)
        } else {
          this.notList = true
          return
        }
      }
    }
  },
  watch: {
    "searchData.LiveName" (newData) {
      console.log(newData, 'newData')
      this.totalArticleList = []
      this.pageIndex = 1

      this.searchData.LiveName = newData.trim()
      let fields = this.fieldsList.filter(val => val.checked)
      if (this.canSearch){
        this.getArticals(this.userInfo.department, fields)
      }
    }
  }
}
</script>
<style scoped>
  #articalCollections {
    width: 100%;
  }
  .top-header {
    width: 100%;
    height: 60px;
  }
  .header-bg {
    width: 100%;
    height: 90px;
    background-color: #FF4D4F;
    border-radius: 0px 0px 45px 45px;
    display: flex;
    flex-direction: row;
    padding: 15px 20px;
    box-sizing: border-box;
    justify-content: space-around;
  }
  .search {
    width: 100%;
    height: 35px;
    position: relative;
  }
  .searchBar {
    width: 100%;
    height: 35px;
    line-height: 35px;
    border: none;
    border-radius: 30px;
    background-color: #E71222;
    box-sizing: border-box;
    color: #ffffff;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
  }
  .search-icon {
    color: #ffffff;
    position: absolute;
    left: 3px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 27px!important;
    font-weight: bold;
  }
  .empty-icon {
    color: #ffffff;
    position: absolute;
    right: 3px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 27px!important;
    font-weight: bold;
  }
  .top-menu {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #E71222;
    text-align: center;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
    position: relative;
  }
  .top-menu-active {
    background-color: #ffffff;
  }
  .top-menu-list {
    width: 100px;
    background-color: #FFFFFF;
    padding: 15px 5px;
    border-radius: 10px;
    position: absolute;
    right: 22px;
    top: 28px;
    z-index: 1;
  }
  .menu-icon {
    color: #ffffff;
    line-height: 35px;
  }
  .menu-icon-active {
    color: #E71222;
  }
  .carousel-container {
    width: 90%;
    height: 160px;
    margin: 0 auto;
    position: relative;
  }
  .carousel-list {
    width: 100%;
    height: 220px;
    margin: 0 auto;
    border-radius: 15px;
  }
  .artical-container {
    width: 100%;
    background-color: #ffffff;
    border-radius: 45px 45px 0px 0px;
    /* min-height: 502px; */
    /* padding-top: 90px; */
    min-height: calc(100vh - 90px);
    padding-bottom: 50px;
    padding-top: 30px;
		box-sizing: border-box;
  }
  .artical-header {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: row-reverse;
    /* justify-content: space-between; */
    margin-bottom: 20px;
  }
  .recommend,
  .interest {
    height: 30px;
    box-sizing: border-box;
  }
  .interest {
    border-radius: 20px;
    border: 1px solid #E71222;
    padding: 0 15px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  }
  .recommend-txt,
  .interest-txt {
    color: rgb(16, 16, 16);
    font-size: 16px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    line-height: 30px;
    margin-left: 5px;
  }
  .interest-txt {
    color: #E71222;
  }
  .artical-list {
    width: 90%;
    margin: 0 auto;
  }
  .artical-item {
    width: 100%;
    margin-bottom: 20px;
  }
  .artical-item-pic {
    overflow: hidden;
    border-radius: 15px;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
  }
  .artical-item-pic .img {
    display: block;
    width: 100%;
  }
  .artical-item-info {
    display: flex;
    flex-direction: row;
    margin-top: 6px;
  }
  .colorful-boder {
    min-height: 40px;
    width: 10px;
    border-radius: 15px;
    background-image: linear-gradient(to bottom, #E71222, #FBAEA6);
  }
  .right {
    padding: 5px 7px;
  }
  .right .item-info-title {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }
  .right .item-info-read {

  }
  .right .item-info-read .num {
    /* color: rgb(192,192,192); */
    color: rgb(137,137,137);
    font-size: 12px;
    margin-right: 5px;
  }
		.onLive-item {
		position: relative;
	}
  .onLive-item > div{
    width: 100%;
    margin-bottom: 20px;
		background-color: #FFFFFF;
		padding: 12px;
		box-sizing: border-box;
		border-radius: 15px 0px 0px 38px;
		position: relative;
		z-index: 1;
  }
	  .onLive-item::after{
			content: '';
			display: block;
			width: 100%;
			height: 100%;
			position: absolute;
			top: 8px;
			left: 4px;
			border-radius: 15px 0px 0px 38px;
			background-color: #F8CDC0;
		}
</style>



// WEBPACK FOOTER //
// src/components/pages/mobileOnLive/mobileOnLiveSearch.vue